'use client';

import React, { createRef, FC } from 'react';
import {
  IBottomSheetProps,
  BottomSheet as UiKitBottomSheet,
} from '@mofid-securities/uikit';
import { withNoSSR } from '@/components/NoSSR';
import {
  getRefMethods,
  TOverlayRef,
  useOverlayImperativeHandle,
} from '@/hooks/overlayImperativeHandle';
import { useRouteChange } from '@/hooks/routeChange';
import { classnames } from '@/utils/classnames';

export interface IBottomSheetParam
  extends Omit<IBottomSheetProps, 'isOpen' | 'closeAction'>,
    Partial<Pick<IBottomSheetProps, 'closeAction'>> {
  shouldCloseOnRouteChanged?: boolean;
  isModal?: boolean;
}

const defaultParam: IBottomSheetParam = { children: null };

const ref = createRef<TOverlayRef<IBottomSheetParam>>();

export const BottomSheetContainer: FC = withNoSSR(() => {
  const { param, close } = useOverlayImperativeHandle<IBottomSheetParam>(
    ref,
    defaultParam
  );

  const { shouldCloseOnRouteChanged, isModal = false, isDraggable } = param;

  useRouteChange(() => {
    if (shouldCloseOnRouteChanged) close();
  });

  return (
    <UiKitBottomSheet
      closeAction={close}
      {...param}
      classNames={{
        ...(param?.classNames ?? {}),
        overlay: classnames('!z-[99999]', param?.classNames?.overlay),
        sheet: classnames(
          param?.classNames?.sheet,
          isModal &&
            '!bottom-auto !left-auto !right-auto !top-auto min-w-[450px] !rounded-2xl'
        ),
      }}
      isDraggable={isModal ? false : isDraggable}
      isOpen={param.isOpen}
    >
      {param.children}
    </UiKitBottomSheet>
  );
});

const BottomSheet = getRefMethods<IBottomSheetParam>(ref);
export default BottomSheet;
